import { makeImmutable } from "../core";
import { ConditionallyAvailableSpec, Parametrization, TemporarilyUnavailableSpec, } from "../ordering";
export class AvailabilitySpecParser {
    constructor(params) {
        this.parametrizationParser = params.parametrizationParser;
        makeImmutable(this);
    }
    parse(availability, availabilityParametric, availabilitySchedule = null) {
        switch (availability) {
            case "Hidden":
                throw new Error("Hidden elements should be filtered beforehand");
            case "TemporarilyUnavailable":
                return new TemporarilyUnavailableSpec();
            case "Available": {
                let availabilityParametrization = this.parametrizationParser.parse(availabilityParametric);
                if (availabilitySchedule !== null) {
                    availabilityParametrization = availabilityParametrization.combine(Parametrization.fromSchedule(availabilitySchedule), (a, b) => a && b);
                }
                return new ConditionallyAvailableSpec({
                    availabilityParametrization,
                });
            }
        }
    }
}
